"use client";
import React, { useEffect, useState } from "react";
import Image from "next/image";
import { Link } from "@/navigation";
import { useTranslations } from "next-intl";
import { ProductListItemFragment } from "@/gql/graphql";
import { filterCateImg } from "@/components/Home2/Collection";
import { defaultLocale } from "@/config";
import { Button } from "../Button";
import { Placeholder } from "../Placeholder";
import { BodyText } from "../BodyText";
import Rating from "react-rating";
import { log } from "console";
import HoverIcon from "./HoverIcon";
import Price from "@/components/Price/price";
import { useUserAuth } from "@/lib/hooks/useUserAuth";
import { App } from "antd";
import { useShoppingCart } from "@/lib/hooks/useShoppingCart";
import { useShoppingCartStore } from "@/lib/store/shoppingCart";
import { useRouter } from "@/navigation";
import { useUserStore } from "@/store/user.store";
import clsx from "clsx";
import { useLoveStore } from "@/lib/store/love.store";

type dscObj = {
	data: { text: string };
	type: string;
};
type dscList = {
	blocks: dscObj[];
};
export const filterSortDsc = (dsc: string) => {
	let sortDsc = "";
	let longDsc = "";
	if (dsc) {
		const dscObj = JSON.parse(dsc) as dscList;

		if (dscObj && dscObj.blocks.length > 0) {
			sortDsc = dscObj.blocks[1].data.text;
			longDsc = dscObj.blocks[0].data.text;
		}
	}

	return { sortDsc, longDsc };
};
export default function ProductCard({ productItem, locale, haveButton = "true" }) {
	const t = useTranslations();
	let router = useRouter();
	const { userInfo, getUserInfo, openLoginModal, setOpenLoginModal } = useUserStore();

	const { isLogin } = useUserAuth();
	const { message } = App.useApp();
	const { addToCart, createBuyBowCheckout } = useShoppingCart();
	const { setisCart, BuyBowcheckoutId, BuyBowCartList } = useShoppingCartStore() as any;
	// state
	let [VariantActive, setVariantActive] = useState<any>(productItem.variants[0]);
	let [Variant, setVariant] = useState<any>(productItem.variants[0]);
	const [loading, setLoading] = useState(false);

	const handlerAttribute = (item: any) => {
		setVariantActive(item);
		setVariant(item);
		// console.log("this is  VariantActive", VariantActive);
	};

	async function AddCart() {
		// if (!isLogin()) {
		// 	setOpenLoginModal(true);
		// 	message.error("NOT Login");
		// 	const login = document.querySelector("#web-login") as HTMLLIElement;
		// 	return login.click();
		// }
		if (!VariantActive) return;
		setLoading(true);
		// @ts-ignore
		await addToCart({
			channel: "default-channel",
			selectedVariantID: VariantActive.id,
			quantity: 1,
		});
		return setLoading(false);
	}
	async function BuyBow() {
		// if (!isLogin()) {
		// 	setOpenLoginModal(true);
		// 	message.error("NOT Login");
		// 	const login = document.querySelector("#web-login") as HTMLLIElement;
		// 	return login.click();
		// }
		if (!VariantActive) return;
		setLoading(true);
		// @ts-ignore
		await createBuyBowCheckout({
			channel: "default-channel",
			selectedVariantID: VariantActive.id,
			quantity: 1,
		});
		setLoading(false);
		setisCart(false);
		router.push("/checkout");
	}
	useEffect(() => {
		// console.log("this is productItem", productItem);
	}, []);
	return (
		<>
			{
				<div
					className={`group relative   flex h-full w-full flex-col justify-between  rounded-[5px] bg-white ${
						haveButton === "true" ? "shadow-md" : ""
					}   duration-300 hover:shadow-2xl`}
				>
					{/* 悬停小标 */}
					<HoverIcon AddCart={AddCart} BuyBow={BuyBow} product={productItem}></HoverIcon>
					{/* card */}
					<div className="relative flex items-center justify-center overflow-hidden pb-[40px] pt-[20px] duration-300">
						{/* 添加loading蒙层 */}
						{loading && (
							<div className="absolute inset-0 z-10 flex items-center justify-center bg-black/30">
								<div className="relative h-10 w-10">
									<div className="absolute h-full w-full animate-spin rounded-full border-[3px] border-white border-t-transparent"></div>
									<div className="absolute h-full w-full animate-ping rounded-full border-[3px] border-white opacity-75"></div>
								</div>
							</div>
						)}
						<Link href={"/product/" + productItem.slug} className="c-flex">
							<Placeholder
								alt={
									locale === defaultLocale
										? productItem.name
										: productItem.translation.name || productItem.name
								}
								src={filterCateImg(productItem.metadata)[0]?.url || "/image/default-image.webp"}
								quality={60}
								imageHeight={300}
								imageWidth={300}
								fit="cover"
								className="mx-auto duration-200  ease-in-out hover:scale-110"
							/>
						</Link>
					</div>
					<div className="px-4 py-6">
						<h3 className="!font-poppins  mt-2 line-clamp-1 text-[16px]  leading-[21px] text-black">
							{locale === defaultLocale ? productItem.name : productItem.translation.name || productItem.name}
						</h3>
						<div className="!font-poppins flex gap-1 text-[16px] font-bold">
							{/* <p className="!font-poppins  my-2 line-clamp-1 text-[16px]  leading-[21px] text-black">
								<Price price={Variant?.pricing?.price.gross.currency || ""}  />
							</p> */}
							<p className="!font-poppins  my-2 line-clamp-1 text-[16px]  leading-[21px] text-black">
								<Price price={Variant?.pricing?.price.gross.amount || ""} />
							</p>
						</div>
						{/* @ts-ignore */}
						{/* <Rating
							readonly
							//  @ts-ignore
							initialRating={productItem.rating > 5 ? 5 : productItem.rating || 5}
							emptySymbol={<i className="ri-star-fill text-themeSecondary300 max-md:text-sm" />}
							fullSymbol={<i className="ri-star-fill text-themeWarning500 max-md:text-sm" />}
						/> */}
						{/* <p className="my-2 line-clamp-3 text-xs font-normal text-[#677E6E] max-md:my-1 sm:text-sm ">
							{locale === defaultLocale
								? filterSortDsc(productItem?.descriptionJson).sortDsc
								: filterSortDsc(productItem?.translation?.descriptionJson).sortDsc}
						</p> */}

						<Link
							href={`/product/${productItem.slug}`}
							className={`c-flex w-full ${haveButton === "true" ? "" : "!hidden"}`}
						>
							<Button
								size="xs"
								className="w-full border-[1px] border-black bg-white !px-[50px] !text-black hover:!text-white max-md:text-[14px]"
							>
								{t("base.viewMore")}
							</Button>
						</Link>
						<div className="mt-3 flex flex-wrap items-center justify-start gap-2 ">
							<p className="font-abeezee font-bold">var:</p>
							{productItem.variants?.length > 0 &&
								productItem.variants?.map((item: any) => {
									return (
										<button
											className={`h-[22px] w-fit rounded-lg px-2 text-[10px] text-black ${
												item == VariantActive ? "bg-main text-white" : ""
											}`}
											key={item.name}
											onClick={() => handlerAttribute(item)}
										>
											{item.name}
										</button>
									);
								})}
						</div>

						{/* <span className="text-xs font-bold  text-main ">{t("base.viewMore")}</span> */}
					</div>
				</div>
			}
		</>
	);
}
export function IconLove(props: { product?: any }) {
	let product = props.product;

	const [isLove, setIsLove] = useState(false);
	const { loveIds, setLoveProducts } = useLoveStore();
	const t = useTranslations();

	// console.log(loveIds,'product');
	useEffect(() => {
		if (loveIds.length && product?.id) {
			setIsLove(loveIds.includes(product.id));
		} else {
			setIsLove(false);
		}
	}, [loveIds]);
	const addOrDelLike = (event: React.MouseEvent) => {
		event.stopPropagation(); //
		const id = product?.id;
		if (id) {
			setLoveProducts(id);
		}
	};
	return (
		<i
			onClick={addOrDelLike}
			className={clsx(
				" text-xl text-[#000]",
				isLove ? " ri-heart-fill !text-[#d53a3d]" : "ri-heart-line !text-[#000]",
			)}
		></i>
	);
}
